<script>
import { required } from "vuelidate/lib/validators";
import { fileSize, fileType } from "../../../helpers/validators_files";

export default {
  components: {},
  props: {},
  data() {
    return {
      attachment_basic: "",
      attachment_info: "",
      attachment_loan: "",
    };
  },
  validations: {
    attachment_basic: {
      required,
      fileType: fileType("application/pdf"),
      fileSize: fileSize(1024 * 1024 * 2),
    },
    attachment_info: {
      // required,
      fileType: fileType("application/pdf"),
      fileSize: fileSize(1024 * 1024 * 2),
    },
    attachment_loan: {
      required,
      fileType: fileType("application/pdf"),
      fileSize: fileSize(1024 * 1024 * 2),
    },
    form: ["attachment_basic", "attachment_info", "attachment_loan"],
  },

  methods: {
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
    chnageFile(e) {
      this[e.target.id] = e.target.files.length > 0 ? e.target.files[0] : null;
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">اضافة المرفقات</h5></div>
      <div class="col-md-12">
        <div class="">
          <h5 class="mb-4">يجب قراءة التعليمات الخاصة برفع المرفقات</h5>

          <ul class="verti-timeline list-unstyled mb-2">
            <li class="event-list">
              <div class="event-timeline-dot">
                <i class="bx bxs-left-arrow-circle font-color-red"></i>
              </div>
              <div class="media">
                <div class="media-body">
                  <div>
                    <h5 class="font-size-14">
                      البطاقة الوطنية او ما يعادلها (هوية الاحوال المدنية + شهادة الجنسية)
                    </h5>
                    <p class="text-muted">رفع المرفقات من الجانبين الامامي والخلفي .</p>
                  </div>
                </div>
              </div>
            </li>
            <li class="event-list">
              <div class="event-timeline-dot">
                <i class="bx bxs-left-arrow-circle font-color-red"></i>
              </div>
              <div class="media">
                <div class="media-body">
                  <div>
                    <h5 class="font-size-14">البطاقة التموينية</h5>
                    <p class="text-muted">رفع البطاقة التموينية .</p>
                  </div>
                </div>
              </div>
            </li>
            <li class="event-list">
              <div class="event-timeline-dot">
                <i class="bx bxs-left-arrow-circle font-color-red"></i>
              </div>
              <div class="media">
                <div class="media-body">
                  <div>
                    <h5 class="font-size-14">بطاقة السكن</h5>
                    <p class="text-muted">
                      رفع بطاقة السكن من الجانبين الامامي والخلفي .
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li class="event-list">
              <div class="event-timeline-dot">
                <i class="bx bxs-file font-color-blue"></i>
              </div>
              <div class="media">
                <div class="media-body">
                  <div>
                    <h5 class="font-size-14">
                      يجب جمع المرفقات الثبوتية للجريح اعلاه ورفعها بملف واحد بصيغة ( pdf.
                      ) وبحجم لا يتجاوز ( 2mb ) .
                    </h5>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <b-form-group
            class="col-md-12 mb-3"
            label=" المرفقات الثبوتية للجريح :"
            label-for="attachment_basic"
          >
            <div class="custom_file">
              <b-form-file
                id="attachment_basic"
                class=""
                placeholder="اختر المرفق"
                accept=".pdf"
                v-model="attachment_basic"
                @change="chnageFile"
                :class="{ 'is-invalid': $v.attachment_basic.$error }"
              ></b-form-file>
              <div v-if="$v.attachment_basic.$error" class="invalid-feedback">
                <span v-if="!$v.attachment_basic.required">هذا الحقل الزامي</span>
                <span v-if="!$v.attachment_basic.fileSize"
                  >يجب ان لا يتجاوز حجم الملف 2mb</span
                >
                <span v-if="!$v.attachment_basic.fileType"
                  >يجب ان يكون نوع الملف pdf</span
                >
              </div>
            </div>
          </b-form-group>
          <ul class="verti-timeline list-unstyled mb-2">
            <li class="event-list">
              <div class="event-timeline-dot">
                <i class="bx bxs-left-arrow-circle font-color-red"></i>
              </div>
              <div class="media">
                <div class="media-body">
                  <div>
                    <h5 class="font-size-14">مرفق تأييد بالاصابة</h5>
                    <p class="text-muted">
                      مرفق تأييد المجروحية وقرار نسبة العجز من الادارة المركزية حصراً .
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li class="event-list">
              <div class="event-timeline-dot">
                <i class="bx bxs-file font-color-blue"></i>
              </div>
              <div class="media">
                <div class="media-body">
                  <div>
                    <h5 class="font-size-14">
                      يجب جمع مرفقات تأييد الاصابة ورفعها بملف واحد بصيغة ( pdf. ) وبحجم
                      لا يتجاوز ( 2mb ) .
                    </h5>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <b-form-group
            class="col-md-12 mb-3"
            label=" مرفق تأييد الاصابة :"
            label-for="attachment_info"
          >
            <div class="custom_file">
              <b-form-file
                id="attachment_info"
                class=""
                placeholder="اختر المرفق"
                accept=".pdf"
                v-model="attachment_info"
                @change="chnageFile"
                :class="{ 'is-invalid': $v.attachment_info.$error }"
              ></b-form-file>
              <div v-if="$v.attachment_info.$error" class="invalid-feedback">
                <!-- <span v-if="!$v.attachment_info.required">هذا الحقل الزامي</span> -->
                <span v-if="!$v.attachment_info.fileSize"
                  >يجب ان لا يتجاوز حجم الملف 2mb</span
                >
                <span v-if="!$v.attachment_info.fileType">يجب ان يكون نوع الملف pdf</span>
              </div>
            </div>
          </b-form-group>
          <ul class="verti-timeline list-unstyled mb-2">
            <li class="event-list">
              <div class="event-timeline-dot">
                <i class="bx bxs-left-arrow-circle font-color-red"></i>
              </div>
              <div class="media">
                <div class="media-body">
                  <div>
                    <h5 class="font-size-14">مرفق الكشف المصرفي</h5>
                    <p class="text-muted">مرفق الكشف المصرفي للقرض من المصرف المانح .</p>
                  </div>
                </div>
              </div>
            </li>
            <li class="event-list">
              <div class="event-timeline-dot">
                <i class="bx bxs-file font-color-blue"></i>
              </div>
              <div class="media">
                <div class="media-body">
                  <div>
                    <h5 class="font-size-14">
                      يجب رفع مرفق الكشف المصرفي بملف واحد بصيغة ( pdf. ) وبحجم لا يتجاوز
                      ( 2mb ) .
                    </h5>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <b-form-group
            class="col-md-12 mb-3"
            label=" مرفق الكشف المصرفي :"
            label-for="attachment_loan"
          >
            <div class="custom_file">
              <b-form-file
                id="attachment_loan"
                class=""
                placeholder="اختر المرفق"
                accept=".pdf"
                v-model="attachment_loan"
                @change="chnageFile"
                :class="{ 'is-invalid': $v.attachment_loan.$error }"
              ></b-form-file>
              <div v-if="$v.attachment_loan.$error" class="invalid-feedback">
                <span v-if="!$v.attachment_loan.required">هذا الحقل الزامي</span>
                <span v-if="!$v.attachment_loan.fileSize"
                  >يجب ان لا يتجاوز حجم الملف 2mb</span
                >
                <span v-if="!$v.attachment_loan.fileType">يجب ان يكون نوع الملف pdf</span>
              </div>
            </div>
          </b-form-group>
        </div>
      </div>
    </div>
  </div>

  <!-- end page title -->
</template>
